import Chip from "@mui/material/Chip";
import type { JSX } from "react";

export function StatusChip(props: { status: string }) {
  let statusChip: JSX.Element;
  const { status } = props;
  if (status === "completed") {
    statusChip = <Chip label="Завершена" color="success" size="small" />;
  } else {
    if (status === "cancelled") {
      statusChip = <Chip label="Отменена" color="default" size="small" />;
    } else {
      if (status === "in_progress") {
        statusChip = <Chip label="В процессе" color="info" size="small" />;
      } else {
        statusChip = <Chip label={status} size="small" />;
      }
    }
  }
  return statusChip;
}
